// extracted by mini-css-extract-plugin
export var externalLink = "_ak-0";
export var internalLinkLabel = "_ak-1";